// extracted by mini-css-extract-plugin
export default {"filter":"EditQuestion_filter__XtOVN","fadeIn":"EditQuestion_fadeIn__KczQ9","tblheader":"EditQuestion_tblheader__Pnlqe","btn":"EditQuestion_btn__CfZjX"};